// Modules
import { BottomSheet } from 'components'
import React, { ReactNode } from 'react'
import { Icon } from '@dasa-health/alma-react'
import { Close, Whatsapp } from '@dasa-health/alma-icons'

// Application
import { userDeviceDetect } from 'utils'

// Components
import {
    BottomSheetContent,
    BottomSheetTitle,
    BottomSheetWrapper,
    BottomSheetButtonWrapper,
    BottomSheetTitleContainer,
    CustomButton,
} from './styles'
import { useHistory } from 'react-router-dom'
import { ROUTES_PATH } from 'constants/routesPath'
import { CustomModalFeedbackUnico } from 'redesign/components/atoms/CustomModalFeedbackUnico'

export interface SignUpModalProps {
    showModal: boolean
    setShowModal: (isOpen: boolean) => void
    title?: string
    children?: ReactNode
    hasCipPassword?: boolean
}

export const ModalFeedbackUnicoTemplate = ({ showModal, setShowModal, title, children, hasCipPassword = true }: SignUpModalProps) => {
    const history = useHistory()

    const { isPortable } = userDeviceDetect()

    const buttonData = {
        href: 'https://api.whatsapp.com/send/?phone=551140202117',
        icon: <Whatsapp />,
        taget: '_blank',
    }

    function handleClose() {
        return setShowModal(false)
    }

    function handleClick() {
        return history.push(ROUTES_PATH.SIGN_IN)
    }

    return (
        <>
            {showModal && !isPortable && (
                <CustomModalFeedbackUnico
                    buttonData={buttonData}
                    onClick={handleClick}
                    onClose={handleClose}
                    open={showModal}
                    title={title}
                >
                    {children}
                </CustomModalFeedbackUnico>
            )}
            {showModal && isPortable && (
                <BottomSheet isOpen={showModal} onRequestClose={handleClose}>
                    <BottomSheetWrapper>
                        <BottomSheetTitleContainer>
                            {title && <BottomSheetTitle>{title}</BottomSheetTitle>}{' '}
                            <button data-testid="close-button" onClick={() => setShowModal(false)} type="button">
                                <Icon size="lg">
                                    <Close />
                                </Icon>
                            </button>
                        </BottomSheetTitleContainer>
                        {children && <BottomSheetContent>{children}</BottomSheetContent>}
                        <BottomSheetButtonWrapper>
                            <CustomButton
                                data-current-service="Reconhecimento Facial"
                                data-item-position="Modal Falha no reconhecimento facial"
                                data-item-text="Falar com atendente"
                                href={buttonData.href}
                                onClick={handleClick}
                                target={buttonData.taget}
                                title="Falar com atendente"
                                type="button"
                            >
                                {buttonData.icon && <Icon size="lg">{buttonData.icon}</Icon>}
                                Falar com atendente
                            </CustomButton>
                        </BottomSheetButtonWrapper>
                    </BottomSheetWrapper>
                </BottomSheet>
            )}
        </>
    )
}
